import React from 'react'
import ReportView from '../../views/Admin/Report/ReportView'

export default function Report(props) {
    return (
        <div>
            <ReportView props={props}/>
        </div>
    )
}
